import * as React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';
import { styled, makeStyles } from '@material-ui/core/styles';
import { Paper, Card } from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
  sliderLabel: {
    color: "#002D55",
    fontWeight: "bold",
    marginBottom: 8,
    marginTop: 0,
    marginLeft: 0,
    marginRight: 0,
    textAlign: "left",
    [theme.breakpoints.up('md')]: { fontSize: '1.2rem', marginTop: 0 },
    [theme.breakpoints.down('md')]: { fontSize: '1.05rem', marginTop: 0 },
    [theme.breakpoints.down('sm')]: { fontSize: '0.95rem', marginTop: 0 },
    [theme.breakpoints.down('xs')]: { fontSize: '0.9rem', marginTop: 0 }
  },
  markLabel: {
    fontSize: 18,
    fontWeight: 500,
    color: "#002D55",
    [theme.breakpoints.down('xl')]: { fontSize: '1.05rem' },
    [theme.breakpoints.down('lg')]: { fontSize: '1.0rem' },
    [theme.breakpoints.down('md')]: { fontSize: '0.95rem' },
    [theme.breakpoints.down('sm')]: { fontSize: '0.88rem' },
    [theme.breakpoints.down('xs')]: { fontSize: '0.8rem' },
  },
}));

export const marks = [
  {
    value: 0,
    label: 'Good.',
  },
  {
    value: 33.33,
    label: 'Too easy.',
  },
  {
    value: 66.66,
    label: 'Too hard.',
  },
  {
    value: 100,
    label: 'Lack equipment.',
  },
];

export const feedbackMessages = {
  0: "We noted that your exercise was a good fit.\n We'll continue as planned.",
  33.33: "We understand the exercise was too easy.\nNext time you will get a harder exercise.",
  66.66: "We understand the exercise was too hard.\nWe'll adjust to make it easier next time.",
  100: "We understand you didn't have the equipment.\nWe'll provide an alternative for next session."
};

function valuetext(value) {
  return `${value}°C`;
}

function valueLabelFormat(value) {
  return marks.findIndex((mark) => mark.value === value) + 1;
}

const PrettoSlider = styled(Slider)(({ theme }) => ({
  color: 'transparent',
  height: 1,
  width: "77%",
  marginLeft: 22,
  marginBottom: 25,
  [theme.breakpoints.down('md')]: {
    marginLeft: 22,
    marginBottom: 18,
  },
  [theme.breakpoints.down('sm')]: {
    marginLeft: 18,
    marginBottom: 14,
  },
  '& .MuiSlider-thumb': {
    height: 22,
    width: 22,
    backgroundColor: '#fff',
    border: '2px solid #fb741a',
    marginTop: -10,
    marginLeft: -11,
    [theme.breakpoints.down('md')]: {
      height: 18,
      width: 18,
      marginTop: -8,
      marginLeft: -9,
    },
    [theme.breakpoints.down('sm')]: {
      height: 16,
      width: 16,
      marginTop: -7,
      marginLeft: -8,
    },
    '&:focus, &:hover, &.Mui-active': {
      boxShadow: 'inherit',
    },
  },
  '& .MuiSlider-valueLabel': {
    left: 'calc(-25% + 4px)',
    scale: (0.01),
    
  },
  '& .MuiSlider-track': {
    height: 15,
    borderRadius: 4,
    opacity: 0.01,
    [theme.breakpoints.down('md')]: {
      height: 12,
    },
    [theme.breakpoints.down('sm')]: {
      height: 10,
    },
  },
  '& .MuiSlider-rail': {
    height: 15,
    borderRadius: 4,
    backgroundColor: "transparent",
    [theme.breakpoints.down('md')]: {
      height: 12,
    },
    [theme.breakpoints.down('sm')]: {
      height: 10,
    },
  },
  '& .MuiSlider-markLabel': {
    fontWeight: 400,
    paddingLeft: 5,
    color: '#002D55',
    fontSize: 'clamp(0.95rem, 1.5vw, 1rem)',
    [theme.breakpoints.down('xl')]: { fontSize: '1.05rem' },
    [theme.breakpoints.down('lg')]: { fontSize: '1.0rem' },
    [theme.breakpoints.down('md')]: { fontSize: '0.9rem' },
    [theme.breakpoints.down('sm')]: { fontSize: '0.88rem' },
    [theme.breakpoints.down('xs')]: { fontSize: '0.8rem' },
  },
}));

export default function DifficultySlider(props, feedbackMessages) {
  const classes = useStyles();
  return (
    <Box>
      <Typography
        variant="h5"
        classes={{ root: classes.sliderLabel }}
        id="discrete-slider-restrict"
        gutterBottom
      >
        How difficult was your exercise?
      </Typography>
      <PrettoSlider
        defaultValue={0}
        valueLabelFormat={valueLabelFormat}
        getAriaValueText={valuetext}
        aria-labelledby="discrete-slider-restrict"
        step={null}
        onChange={(event, val) => {
          console.log(val)
          props.setValue(val)
        }}
        value={props.value}
        valueLabelDisplay="auto"
        marks={marks}
      />
      {/* Feedback message preview (if needed) */}
      {typeof props.value !== 'undefined' && feedbackMessages && feedbackMessages[props.value] && (
        <Typography style={{ color: '#002D55', marginTop: 8, fontSize: 16 }}>
          {feedbackMessages[props.value]}
        </Typography>
      )}
    </Box>
  );
}